import { Grid, Tab, Tabs, useTheme } from "@mui/material"
import { useEffect, useState } from "react";
import { MyData } from "./tapOptions-0";
// import { MyPosition } from "./tapOptions-1";
import { Plans, Record } from "./tapOptions-2";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getEmployeeContracts, getEmployeeHealthPlan } from "../../../api/signalApi";
import { EmployeContracts } from "../../../interfaces/employeeDocuments.interface";
import { EMPLOYEE_CONTRACTS_ONE } from "../../../constants/signalRequestConsts";

const MyFile = () => {
    const theme = useTheme();
    const {companyselected, connectionId, userHealthPlan} = useSelector((state: RootState) => state.auth);
    const {contracts} = useSelector((state: RootState) => state.documents[EMPLOYEE_CONTRACTS_ONE]);
    const [tabOptionSelected, setTabOptionSelected] = useState(0);
    const [contractsInformation, setContractsInformation] = useState<EmployeContracts[]>([]);

    const tabOptions = [{
            label: "Mis datos",
        },{
        //     label: "Mi cargo", 
        // },{
            label: "Historial",
        },
    ];

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabOptionSelected(newValue);
    };

    useEffect(() => {
        const newList = [...contracts];
        newList.sort((a, b) => {
            const fechaA = new Date(a.FechaInicio);
            const fechaB = new Date(b.FechaInicio);
            if (fechaA < fechaB) {
              return 1;
            } else if (fechaA > fechaB) {
              return -1;
            } else {
              return 0;
            }
        });
        setContractsInformation(newList)
    }, [contracts]);

    useEffect(() => {
        if (!companyselected || !connectionId) return;
        getEmployeeContracts(0, EMPLOYEE_CONTRACTS_ONE);
        getEmployeeHealthPlan();
    }, [companyselected, connectionId]);


    return (

        <Grid item width="100%" marginTop="1.5rem" minHeight="60%">
            {/* <Paper
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "1.5rem",
                }}
            > */}

                <Grid sx={{ borderBottom: 1, borderColor: '#E8E8E8', marginBottom: "1.5rem" }}>
                    <Tabs value={tabOptionSelected} onChange={handleChange} aria-label="basic tabs example">
                        {tabOptions.map((t, i) => (
                            <Tab key={i} label={t.label} style={{
                                color: i === tabOptionSelected 
                                    ? `${theme.s10palette.S10Blueblue600}` 
                                    : `${theme.s10palette.S10Greygrey300}`,
                                fontFamily: 'Roboto',
                                fontSize: '1rem',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                            }} />
                        ))}
                    </Tabs>
                </Grid>
                {tabOptionSelected === 0 && <MyData contractInformation={contractsInformation.length ? contractsInformation[0] : null} />}
                {/* {tabOptionSelected === 1 && 
                    <MyPosition 
                        contractInformation={contractsInformation.length ? contractsInformation[0] : null} 
                    />} */}
                {tabOptionSelected === 1 && <Record contracts={contractsInformation} />}
                
            {/* </Paper> */}
            {tabOptionSelected === 1 && <Plans data={userHealthPlan} />}
        </Grid>
    )
}

export default MyFile;